import React from 'react';
import { Provider } from "react-redux";
import appStore from "../redux/store/appStore";

const ReduxProvider = ({ children }) => <Provider store={ appStore }>{ children }</Provider>

export default ReduxProvider;